import { differenceInDays, formatDistanceStrict, intlFormat } from 'date-fns'

import { selectDateFnsLocale } from '~/helpers/selectDateFnsLocale'

import type { Language } from '~/types/language'
import type { Locale } from '~/types/locale'

/**
 * It's important to note that this should be called "formatTimeSinceRightNowInThePresentMoment"
 */
export function formatTimeSince(date: Date, language: Language): string {
  return formatDistanceStrict(date, new Date(), {
    locale: selectDateFnsLocale(language),
    addSuffix: true,
  })
}

export function toUTC(date: Date): number {
  return Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
  )
}

export function remainingDays(date: string, maxDays = 7 as number): number {
  const diff = differenceInDays(toUTC(new Date(date)), toUTC(new Date()))

  return diff <= maxDays ? diff : maxDays
}

/**
 * Returns a formatted date string in the format "October 1, 2023" using the provided locale.
 *
 * @param date - a date string in ISO format (e.g., "2023-10-01T12:00:00Z")
 * @returns A long form string of a date such as "October 1, 2023"
 */
export function formatDateAsLongStringWithLocale(
  date: string | null | undefined,
  locale: Locale,
) {
  if (!date) return ''
  return intlFormat(
    new Date(date),
    {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    },
    {
      locale: locale,
    },
  )
}
